import { useContext, useEffect, memo } from "react"
import { Flex, Box, Text } from "@chakra-ui/react"
import { useRecoilState, useRecoilValue } from "recoil"
import { MessageInput } from "../message-input"
import { ChatCloseIcon } from "./_chatCloseIcon"
import { TargetUser } from "../../../recoil/atoms/chats/types"
import {
  chatAttachmentReplyDataAtom,
  chatScrollAtom,
  isSavingChatAttachmentReply
} from "../../../recoil/atoms/chats"
import { usersSelector } from "../../../recoil/atoms/users"
import { ChatStyles } from "./index"
import { useTranslation } from "react-i18next"
import { viewDependingLayoutAtom } from "../../../recoil/atoms/view"
import ChatAttachmentPreview from "./_chatAttachmentPreview"
import { brandingSelector } from "src/recoil/atoms/room"

interface ChatReplyProps {
  borderColor: string
  published: boolean
  isApproved: boolean
  handleSendMessage: (
    message: string,
    parentChatId: string,
    userId: string
  ) => void
  isPrivateMessage: boolean
  setIsReply: any
  positionModal: { x: number; y: number }
  handleAssignPosition: (e: any) => void
  chatId: string
  isMobile?: boolean
  isReply?: boolean
  isModerator?: boolean
  haveRiplys: boolean
  targetUser: TargetUser
  isLocalUserChatAuthor: boolean
  localUserId: string
  styleschat: ChatStyles
  isParent?: boolean
  hideEmodji?: boolean
}

const _ChatReplyInput: React.FC<ChatReplyProps> = ({
  published,
  borderColor,
  isApproved,
  setIsReply,
  handleSendMessage,
  isPrivateMessage,
  chatId,
  positionModal,
  handleAssignPosition,
  isMobile,
  isReply,
  isModerator,
  haveRiplys,
  targetUser,
  isLocalUserChatAuthor,
  localUserId,
  styleschat,
  isParent,
  hideEmodji
}) => {
  const { t } = useTranslation()
  const [, setIsChatIsScroll] = useRecoilState(chatScrollAtom)
  const { isTransparent } = useRecoilValue(viewDependingLayoutAtom)
  const [attachment, setAttachment] = useRecoilState(chatAttachmentReplyDataAtom)
  const removeAttachment = () => setAttachment({ data: "", mimeType: "" })
  const roomStyles = useRecoilValue(brandingSelector)
  const saving = useRecoilValue(isSavingChatAttachmentReply)

  useEffect(() => {
    if (
      /* !isReplyMessage && */
      isPrivateMessage &&
      targetUser &&
      Object.entries(targetUser)?.length === 0
    ) {
      setIsChatIsScroll(true)
    }
  }, [isPrivateMessage, setIsChatIsScroll, targetUser])

  const targetUserData = useRecoilValue(
    usersSelector(isLocalUserChatAuthor ? targetUser?.id : localUserId)
  )

  return (
    <>
      {!isMobile && (
        <Flex
          marginLeft="2rem"
          fontSize="sm"
          height={isReply /*  || isReplyMessage */ ? "0.7rem" : "unset"}
          borderLeft={isMobile ? "none" : `2px solid ${borderColor}`}
        ></Flex>
      )}
      <Flex
        border={isMobile ? "none" : `2px solid ${borderColor}`}
        borderRadius={isMobile ? "0rem" : "0.6rem"}
        backgroundColor={!isParent && styleschat?.servicePanelElementBackground}
        zIndex={10000000}
        borderBottomRightRadius={
          isMobile && isReply && !isTransparent && "0.5rem"
        }
        borderBottomLeftRadius={
          isMobile && isReply && !isTransparent && "0.5rem"
        }
        pos="relative"
        id={`input-reply-${chatId}`}
        marginLeft={haveRiplys && isReply && !isMobile && "1rem"}
      >
        {!isMobile && (
          <ChatCloseIcon
            styleschat={styleschat}
            isMobile={isMobile}
            callback={() => setIsReply(prev => !prev)}
          />
        )}
        <Box
          d="flex"
          justifyContent="space-between"
          flexDir="column"
          maxW="100%"
          w="100%"
          margin={!isParent ? "0.2rem" : "0rem"}
        >
          {
            // !isReplyMessage &&
            isPrivateMessage && targetUserData === null ? (
              <Flex
                bgColor={styleschat?.commentBackgroundColor ?? "white"}
                width="100%"
                borderRadius="0.4rem"
                p="0.3rem"
              >
                <Text fontSize="sm" pl="0.33rem">
                  {t("Intended recipient has left the chat")}
                </Text>
              </Flex>
            ) : (
              <>
                {attachment.data && (
                  <ChatAttachmentPreview
                    attachment={attachment}
                    removeAttachment={removeAttachment}
                    roomStyles={roomStyles}
                    borderColor={borderColor}
                    saving={saving}
                  />
                )}
                <MessageInput
                  hideEmodji={hideEmodji}
                  positionModal={positionModal}
                  callbackEmoji={handleAssignPosition}
                  inputId={`chat-input-${chatId}`}
                  parentMessageId={chatId}
                  userId=""
                  isMobile={isMobile}
                  sendMessage={handleSendMessage}
                  placeholder={
                    !isApproved
                      ? t("Send a private reply...")
                      : t("Send a reply...")
                  }
                  inputLeftElementStyle={{
                    paddingRight: "7px",
                    top: "-1.5px",
                    color: "gray.500"
                  }}
                  inputRightElementStyle={{
                    top: "inherit",
                    paddingTop: "0.2rem",
                    alignItems: "center",
                    width: "42px",
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "0.5rem"
                  }}
                  topPositionError={"-19"}
                  isReply={true}
                />
              </>
            )
          }
        </Box>
      </Flex>
    </>
  )
}

export const ChatReplyInput = memo(_ChatReplyInput)
